import React from 'react'
import classNames from 'classnames'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {AddToCalendar} from './add-to-calendar'
import {DownloadTickets} from './download-tickets'
import {SuccessActionsProps} from './interfaces'
import s from './success-actions.scss'

const getButtonClasses = (primary: boolean = true) => {
  return classNames(s.actionButton, primary ? s.primary : s.secondary)
}

export const SuccessActions: React.FC<SuccessActionsProps> = ({
  t,
  mobile,
  ticketsPdf,
  downloadTickets,
  className = '',
  calendarButtonText = t('ticketsThankYou.addToCalendar'),
  calendarLinks,
  addToCalendarClicked,
  openTicketsDownloadModal,
  downloadTicketsVisible,
  addToCalendarVisible,
}) => {
  if (!downloadTicketsVisible && !addToCalendarVisible) {
    return null
  }

  const handleTickets = () => {
    if (mobile) {
      openTicketsDownloadModal()
    } else {
      window.open(ticketsPdf)
      downloadTickets()
    }
  }

  return (
    <div className={className}>
      {downloadTicketsVisible && (
        <DownloadTickets
          t={t}
          className={classNames(getButtonClasses(), s.primaryActionMargin)}
          onClick={handleTickets}
        />
      )}
      {addToCalendarVisible && (
        <AddToCalendar
          t={t}
          dataHook={DH.ADD_TO_CALENDAR}
          className={getButtonClasses(!downloadTicketsVisible)}
          buttonText={calendarButtonText}
          calendarLinks={calendarLinks}
          onClick={addToCalendarClicked}
        />
      )}
    </div>
  )
}
